import { Tag } from '../../types/tag.type';
import { RentalRow } from '../../types/inventory.type';
import { Match } from '../../types/match.type';
import { TrainingEvent } from '../../types/training-event.type';

export interface BirthdayPerson {
  id: number;
  firstName: string;
  lastName: string;
  age: number;
  date: string; // YYYY-MM-DD — the occurrence date within the requested calendar range
  tags: Tag[];
}

export interface TopScorer {
  personId: number;
  name: string;
  goals: number;
}

export interface TopCards {
  personId: number;
  name: string;
  yellow: number;
  red: number;
}

export interface TopOwnGoals {
  personId: number;
  name: string;
  ownGoals: number;
}

export interface SeasonLeaders {
  topScorers: TopScorer[];
  topCards: TopCards[];
  topOwnGoals: TopOwnGoals[];
}

export interface MatchFilterOptions {
  seasons: string[];
  competitions: string[];
  teams: string[];
}

// Unified per-day entry so matches, trainings and birthdays interleave
// chronologically within a day instead of appearing as disjoint blocks.
export type CalendarEntry =
  | { kind: 'match'; sortMinutes: number; match: Match }
  | { kind: 'training'; sortMinutes: number; training: TrainingEvent }
  | { kind: 'birthday'; sortMinutes: number; birthday: BirthdayPerson }
  // Rentals/reservations of calendar-flagged articles (e.g. the squad bus); a
  // multi-day rental appears on every day of its period.
  | { kind: 'rental'; sortMinutes: number; rental: RentalRow };

export const calendarEntryKey = (item: CalendarEntry) =>
  item.kind === 'match' ? `match-${item.match.id}`
    : item.kind === 'birthday' ? `birthday-${item.birthday.id}`
      : item.kind === 'rental' ? `rental-${item.rental.id}`
        : `training-${item.training.id}`;
